import { get } from 'lodash';

const getApiDomain = () => get(window, 'lifesize.apiDomain') as string || 'lifesizecloudbeta.com';

export default getApiDomain;



// WEBPACK FOOTER //
// ./src/utils/getApiDomain.ts